export enum AuthMethodType {
  Password = 'Username/Password',
  Google = 'Google',
}

export enum CompanyType {
  Admin = 0,
  Customer = 1,
}

export enum UserRoles {
  Admin = 'Admin',
  User = 'User',
  Guest = 'Guest',
}

export enum ViewMode {
  List = 'list',
  Grid = 'grid',
  Chart = 'chart',
}

export enum BotRunStatus {
  OK = 'OK',
  Stopped = 'Stopped',
  Failed = 'Failed',
  Running = 'Running',
}

export enum BotSlowRun {
  Slow = 'slow',
  NotSlow = 'notSlow',
}

export enum OS {
  Windows,
  Other,
}

export enum JointCheckboxState {
  Checked = 'checked',
  Ambiguous = 'ambiguous',
}

export enum TestPurchaseStatus {
  Created = 'Created',
  Requested = 'Requested',
  Completed = 'Completed',
  InProgress = 'In Progress',
}

export enum EnforcementStatus {
  Created = 'Created',
  VerificationRequested = 'Verification Requested',
  AwaitingReview = 'Awaiting Review',
  UnderReview = 'Under Review',
  TakedownRequested = 'Takedown Requested',
  VoluntarilyDelisted = 'Voluntarily Delisted',
  Completed = 'Completed',
  Retracted = 'Retracted',
  Cancelled = 'Cancelled',
}

export enum EnforcementAuditTrailHistoryType {
  Created = 'Created',
  InitialNotificationSentToReseller = 'Initial notification sent to reseller',
  RequestReceivedByReseller = 'Request received by reseller',
  ResponseReceivedFromReseller = 'Response received from reseller',
  TakeDownRequested = 'Take-down requested',
  Cancelled = 'Cancelled',
  Complete = 'Complete',
  MarkedComplete = 'Marked complete',
  VoluntarilyDelisted = 'Voluntarily delisted',
  Paused = 'Paused',
  Resumed = 'Resumed',
  Retracted = 'Retracted',
  RequestDeliveredToReseller = 'Request delivered to reseller',
  RequestNotDeliverableToReseller = 'Request not deliverable to reseller',
  WebformReceivedFromReseller = 'Webform received from reseller',
  WebformDeliveredToReseller = 'Webform delivered to reseller',
  VerificationProcessingFeeRequired = 'Verification processing fee required',
}

export enum StoreStatus {
  ActionInProgress = 'Action in progress',
  Greylisted = 'Greylist',
  Allowed = 'Allowed',
}

export enum DistributorStatus {
  Unknown = 'unknown',
  Authorised = 'authorised',
  NotAuthorised = 'notAuthorised',
}

export const DISTRIBUTOR_STATUS_ID = {
  UNKNOWN: 1,
  AUTHORISED: 2,
  NOT_AUTHORISED: 3,
} as const;

export const DISTRIBUTOR_STATUS_BY_ID: Record<number, DistributorStatus> = {
  [DISTRIBUTOR_STATUS_ID.UNKNOWN]: DistributorStatus.Unknown,
  [DISTRIBUTOR_STATUS_ID.AUTHORISED]: DistributorStatus.Authorised,
  [DISTRIBUTOR_STATUS_ID.NOT_AUTHORISED]: DistributorStatus.NotAuthorised,
};

export enum BotScheduledInfo {
  Scheduled = 'scheduled',
  NotScheduled = 'notScheduled',
}
